import { assign } from 'lodash';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, FormControl } from '@angular/forms';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from '@medsurf/flat-facades';
import { ZodSharedValidator } from '@medsurf/flat-validators';

@Component({
    selector: 'medsurf-slide-edit-media-link',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './media-link.component.html',
    styleUrls: ['./media-link.component.scss'],
    standalone: false
})
export class MediaLinkComponent {
  #isSubmitted = signal(false);
  #image: FlatModels.ImageEntityModels.Image | null;
  linkForm = new FormGroup(
    {
      type: new FormControl<FlatModels.LinkEntityModels.LinkType>('Slide'),
      link: new FormControl<string | number>(''),
    },
    {
      validators: ZodSharedValidator.validate(
        FlatModels.LinkEntityModels.LinkSchema
      ),
      updateOn: 'change'
    }
  );
  readonly FlatModels = FlatModels;

  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
              public slideAuthorFacade: FlatFacades.SlideAuthorFacade) {
    // Update Linking
    this.slideAuthorFacade.currentSelectedSlideImage$.pipe(takeUntilDestroyed()).subscribe((image) => {
      this.#image = structuredClone(image);
      if (this.#image && this.#image.link) {
        this.linkForm.reset({
          type: image?.link?.type || 'Slide',
          link: image?.link?.link,
        });
      }
      this.#isSubmitted.set(false);
    });
  }

  onSubmit() {
    if (this.#isSubmitted() || this.linkForm.invalid || !this.linkForm) {
      return;
    }
    this.#isSubmitted.set(true);
    
    // Update Image
    const image = assign(
      this.#image,
      {
        link: {
          type: this.linkForm.value.type,
          link: this.linkForm.value.link,
        }
      }
    );
    this.slideAuthorFacade.requestUpdateImage(image, 'history.image_update').subscribe({
      error: (result) => {
        ZodSharedValidator.handleError(result, this.alertControlFacade, this.linkForm);
        this.#isSubmitted.set(false);
      },
      next: () => {
        this.#isSubmitted.set(false);
      }
    });
  }
}
